// composables/useAuthApi.ts - 认证相关API封装（Phase3 实装）

import type { LoginData } from '~/types/user'
import type { ApiResponse } from '~/types/api'

/**
 * 认证API Composable
 * 封装 /account/login/device /account/check_token /account/change_token /account/logout
 * 说明：签名、公共字段与错误处理均由 app/plugins/fetch.client.ts 提供的 $api 完成
 */
export function useAuthApi() {
  const api = useNuxtApp().$api as <T = any>(
    path: string,
    opts?: { method?: string; body?: any }
  ) => Promise<ApiResponse<T>>

  async function loginByDevice(deviceId: string): Promise<LoginData> {
    const body = { device_identify_list: [{ device_id_type: 'device_id', device_id: deviceId }] }
    const resp = await api('/account/login/device', { method: 'POST', body })
    const d: any = (resp as any)?.data ?? resp
    return {
      uid: d.uid,
      token: d.token,
      refreshToken: d.refresh_token,
      userName: `user_${d.uid}`,
      avatarUrl: ''
    }
  }

  async function checkToken(): Promise<void> {
    await api('/account/check_token', { method: 'POST', body: {} })
  }

  async function changeToken(refreshToken: string): Promise<{ token: string; refreshToken: string }> {
    const resp = await api('/account/change_token', { method: 'POST', body: { refresh_token: refreshToken } })
    const d: any = (resp as any)?.data ?? resp
    return { token: d.token, refreshToken: d.refresh_token }
  }

  async function logout(): Promise<void> {
    await api('/account/logout', { method: 'POST', body: {} })
  }

  return { loginByDevice, checkToken, changeToken, logout }
}
